import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import {
  Button,
  Form,
  Grid,
  Modal,
  ModalContent,
  TransitionablePortal,
} from "semantic-ui-react";
import { newCategory } from "../../../store/actions/partnersActions";
import { randomName } from "../../../utils/utils";

const AddCategory = (props) => {
  const [name, setName] = useState(null);
  const [error, setError] = useState("Name required");

  const dispatch = useDispatch();

  useEffect(() => {
    if (name) {
      setError(null);
    }
    if (props.newPartnerAdd) {
      handleClose();
    }
  }, [name, props.newPartnerAdd]);

  const handleClose = () => {
    setError(null);
    setName(null);
    props.close();
  };
  const handleSubmit = () => {
    if (name) {
      const id = name.toLowerCase().replace(/ /g, "_");
      const toFirestore = { name, id };
      dispatch(newCategory(toFirestore));
    }
  };
  return (
    <TransitionablePortal
      transition={{ animation: "slide left", duration: "500" }}
      onClose={handleClose}
      open={props.open}
    >
      <Modal
        size="tiny"
        className="cu-event-modal"
        onClose={handleClose}
        open={true}
      >
        <ModalContent>
          <div className="AdminTopButtonsProgressContainer">
            <div className="AdminTopButtonsContainer">
              <Button
                floated="left"
                circular
                icon="close"
                onClick={handleClose}
              />

              <Button
                circular
                disabled={error}
                loading={props.newPartnerAdding}
                floated="right"
                positive
                icon="checkmark"
                onClick={handleSubmit}
              />
            </div>
            {error && <p style={{ color: "#800000" }}>{error}</p>}
            {props.newPartnerAddError && (
              <p style={{ color: "#800000" }}>
                {props.newPartnerAddError.message}
              </p>
            )}
          </div>
          <Form>
            <div className="AdminFormEventContainer add-partner-modal">
              <h3>Add Category</h3>
              <Grid divided="vertically">
                <Grid.Row stackable="true">
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <Form.Field required>
                      <label>Name</label>
                      <input
                        placeholder={randomName(props.categories)}
                        id="partner_category"
                        onChange={(e) => setName(e.target.value)}
                      />
                    </Form.Field>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </Form>
        </ModalContent>
      </Modal>
    </TransitionablePortal>
  );
};

const mapStateToProps = (state) => {
  const partnersOrder = state.firestore.ordered.partnersOrder;
  const categories = [];
  if (partnersOrder && partnersOrder.length > 0) {
    partnersOrder.forEach((category) => {
      if (category.name) {
        categories.push(category.name);
      }
    });
  }

  return {
    categories,
    newPartnerAdd: state.partners.newPartnerAdd,
    newPartnerAddError: state.partners.newPartnerAddError,
    newPartnerAdding: state.partners.newPartnerAdding,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect([
    {
      collection: "partnersOrder",
    },
  ])
)(AddCategory);
